/**
 * States to determine the source of reducer data
 * eg: if reducer update data from localStorage,
 * can maintain a 'source' prop with the following LOCAL_STORAGE value
 */
export const FETCH_SOURCE = {
    INITIAL: 0,
    ACTION: 1,
    LOCAL_STORAGE: 2,
}
